import React from 'react';
import CourseCard from './CourseCard';
import '../../css/CourseList.css';

const CourseList = ({ courses, activeCategory }) => {
    return (
        <>
            <div className="course-bar">
                {courses.map((card, idx) => (
                    <CourseCard
                        key={idx}
                        img={card.img}
                        title={card.title}
                        desc={card.desc}
                        courseType={card.courseType}
                        id={card.id} // pass id only
                    />
                ))}
            </div>
            {activeCategory === 'Popular' && (
                <button
                    className="navbar-signup"
                    id="courseCards-button"
                    onClick={() => alert("under construction!")}
                >
                    Explore all our chapters <i className="bi-caret-right-fill" style={{ marginLeft: '8px' }}></i>
                </button>
            )}
        </>
    );
};

export default CourseList;